import axios from "axios";

const URL = 'https://aiinrealestate.in/api';

// const URL = 'http://localhost:5000';


axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});


export const addMonthUpdate = async (data) => {
    try {
        return await axios.post(`${URL}/Month-Updates`, data);
    } catch (error) {
        console.log("Error while adding month update", error);
        throw error;
    }
};
export const getMonthUpdateAll = async () => {
    try {
        const response = await axios.get(`${URL}/getMonthUpdateAll`);
        return response.data;
    } catch (error) {
        console.log("Error while fetching getMonthUpdateAll", error);
        return { success: false, message: "Failed to fetch getMonthUpdateAll" };
    }
};

export const deletePropertyUpdateDetail = async (id) => {
    try {
        const response = await axios.delete(`${URL}/PropertyupdateDelete/${id}`);
        return response.data;
    } catch (error) {
        console.log("Error while delete Property Update", error);
        return { success: false, message: "Failed to delete Property Update" };
    }
};
export const addWestoriesdetail = async (data) => {
    try {
        return await axios.post(`${URL}/Webstories`, data)
    } catch (error) {
        console.log("Error while adding webstories", error)
    }
}


export const getWebstories = async () => {
    try {
        const response = await axios.get(`${URL}/webstories`);
        return response.data;
    } catch (error) {
        console.log("Error while fetching webstories", error);
        return { success: false, message: "Failed to fetch webstories" };
    }
};

export const deleteWebstory = async (id) => {
    try {
        const response = await axios.delete(`${URL}/webstories/${id}`);
        return response.data;
    } catch (error) {
        console.log("Error while deleting webstory", error);
        return { success: false, message: "Failed to delete webstory" };
    }
};
export const deleteproperty = async (id) => {
    try {
        const response = await axios.delete(`${URL}/property/${id}`);
        return response.data;
    } catch (error) {
        console.log("Error while deleting property", error);
        return { success: false, message: "Failed to delete property" };
    }
};
export const editProperty = async (id, data) => {
    try {
        const response = await axios.put(`${URL}/edit_property/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.log("Error while editing property", error);
        return { success: false, message: "Failed to edit property" };
    }
};

export const Addproperties = async (data) => {
    try {
        return await axios.post(`${URL}/property`, data)
    } catch (error) {
        console.log("Error while inserting property");
    }
}

// export const AddDeveloper = async (data) => {
//     try {
//         return await axios.post(`${URL}/add_developer`, data)
//     } catch (error) {
//         console.log("Error while inserting developer");
//     }
// }

export const AddDeveloper = async (formData) => {
    return await axios.post(`${URL}/add_developer`, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }).then(res => res.data);
};


export const getAllProperties = async () => {
    try {
        const response = await axios.get(`${URL}/property`);
        return response.data;
    } catch (error) {
        console.log("Error while fetching webstories", error);
        return { success: false, message: "Failed to fetch webstories" };
    }
};
export const getAllFestiveProperties = async () => {
    try {
        const response = await axios.get(`${URL}/festive_property`);
        return response.data;
    } catch (error) {
        console.log("Error while fetching webstories", error);
        return { success: false, message: "Failed to fetch webstories" };
    }
};
export const getAll_Category_Properties = async () => {
    try {
        const response = await axios.get(`${URL}/category_property`);
        return response.data;
    } catch (error) {
        console.log("Error while fetching webstories", error);
        return { success: false, message: "Failed to fetch webstories" };
    }
};
export const getdevelopers = async () => {
    try {
        const response = await axios.get(`${URL}/developers`);
        return response.data;
    } catch (error) {
        console.log("Error while fetching developers", error);
        return { success: false, message: "Failed to fetch developers" };
    }
};

export const getDeveloperbyname = async (dev_name) => {
    try {
        return await axios.get(`${URL}/developer/Details/${dev_name}`);
    } catch (error) {
        console.log("Error while calling developer API", error);
    }
}

export const getcities = async () => {
    try {
        const response = await axios.get(`${URL}/cities`);
        return response.data;
    } catch (error) {
        console.log("Error while fetching cities", error);
        return { success: false, message: "Failed to fetch cities" };
    }
};

export const searchProperties = async (query) => {
    try {
        const response = await axios.get(`${URL}/search_property`, {
            params: { query }
        });
        return response.data;
    } catch (error) {
        console.log("Error while searching properties", error);
        return { success: false, message: "Failed to search properties" };
    }
};
export const searchPropertiesoffer = async (query) => {
    try {
        const response = await axios.get(`${URL}/search_propertyoffer`, {
            params: { query }
        });
        return response.data;
    } catch (error) {
        console.log("Error while searching properties", error);
        return { success: false, message: "Failed to search properties" };
    }
};
export const searchProperty = async (query) => {
    try {
        const response = await axios.get(`${URL}/search_properties`, {
            params: { query }
        });
        return response.data;
    } catch (error) {
        console.log("Error while searching properties", error);
        return { success: false, message: "Failed to search properties" };
    }
};

export const searchwebstories = async (query) => {
    try {
        const response = await axios.get(`${URL}/search_webstories`, {
            params: { query }
        });
        return response.data;
    } catch (error) {
        console.log("Error while searching webstories", error);
        return { success: false, message: "Failed to search webstories" };
    }
};

export const getPropertyById = async (id) => {
    try {
        return await axios.get(`${URL}/properties/${id}`);
    } catch (error) {
        console.log("Error while calling property API", error);
    }
}


export const getPropertyByTitle = async (title) => {
    try {
        return await axios.get(`${URL}/property/${title}`);
    } catch (error) {
        console.log("Error while calling property API", error);
    }
}
export const getMonthUpdate = async (id, month, year) => {
    try {
        return await axios.get(`${URL}/getMonthUpdate/${id}/${year}/${month}`);
    } catch (error) {
        0
        console.log("Error while calling property getMonthUpdate API", error);
    }
};


// export const getWebstoryById = async (id) => {
//     try {
//         return await axios.get(`${URL}/webstories/${id}`);
//     } catch (error) {
//         console.log("Error while calling property API", error);
//     }
// }

export const getWebstoryById = async (title) => {
    try {
        return await axios.get(`${URL}/webstories/${title}`);
    } catch (error) {
        console.log("Error while calling property API", error);
    }
}

export const saveFacilities = async (data) => {
    try {
        return await axios.post(`${URL}/facility`, data)
    } catch (error) {
        console.log('Error while inserting facility');
    }
}


export const addAgentApi = async (data) => {
    try {
        return await axios.post(`${URL}/addagent`, data)
    } catch (error) {
        console.log("Error while inserting Agent");
    }
}

// Property Count

export const GetAreaPropertyCount = async () => {
    try {
        const response = await axios.get(`${URL}/AreaPropertyCount`);
        return response.data;
    } catch (error) {
        return { success: false, message: "Failed to fetch Area" };
    }
};

export const AreaPropertyCountUpdate = async (id, data) => {
    try {
        const response = await axios.put(`${URL}/AreaPropertyCountUpdate/${id}`, data);
        return response.data;
    } catch (error) {
        return { success: false, message: "Failed to update property count" };
    }
};

export const updateSequence = async (id, sequence) => {
    try {
        const response = await axios.post(`${URL}/update-sequence`, {
            id,
            sequence,
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const AddAreaPropertyCount = async (data) => {
    try {
        const response = await axios.post(`${URL}/AddAreaPropertyCount`, data);
        return response;
    } catch (error) {
        console.error("Error while inserting AddAreaPropertyCount:", error);
        throw error;
    }
}

export const getAllCategories = async () => {
    try {
        const response = await axios.get(`${URL}/AllCategories`);
        return response.data;
    } catch (error) {
        console.log("Error while fetching AllCategories", error);
        return { success: false, message: "Failed to fetch AllCategories" };
    }
};

export const getCategoriesById = async (id) => {
    try {
        return await axios.get(`${URL}/getCategoryDetail/${id}`);
    } catch (error) {
        console.log("Error while calling Categories API", error);
    }
}

export const assignPropertyToCategory = async (data) => {
    try {
        const response = await axios.post(`${URL}/assignPropertyToCategory`, data);
        return response.data;
    } catch (error) {
        console.error("Error while inserting assignPropertyToCategory:", error);
        return { success: false, message: "Failed to assign property" };
    }
};

export const getAllPropertiesWithOutCat = async () => {
    try {
        const response = await axios.get(`${URL}/getAllPropertiesWithOutCat`);
        return response.data;
    } catch (error) {
        console.log("Error while fetching webstories", error);
        return { success: false, message: "Failed to fetch webstories" };
    }
};

export const deletePropertyFromCategory = async (data) => {
    try {
        return await axios.post(`${URL}/deletePropertyFromCategory`, data);
    } catch (error) {
        console.log("Error while deleting property from category");
    }
};


export const insertFestiveCategory = async (data) => {
    try {
        return await axios.post(`${URL}/festive`, data)
    } catch (error) {
        console.log("Error while inserting festive categories");
    }
}

export const getAllFestiveCategories = async () => {
    try {
        const response = await axios.get(`${URL}/festive`);
        return response.data;
    } catch (error) {
        console.log("Error while fetching festive", error);
        return { success: false, message: "Failed to fetch festive" };
    }
};

export const deleteFestiveCategory = async (id) => {
    try {
        const response = await axios.delete(`${URL}/property/${id}`);
        return response.data;
    } catch (error) {
        console.log("Error while deleting property", error);
        return { success: false, message: "Failed to delete deleteFestiveCategory" };
    }
};

export const insertUser = async (data) => {
    try {
        return await axios.post(`${URL}/user`, data)
    } catch (error) {
        console.log("Error while adding user", error)
    }
}

export const loginUserApi = (data) => {
    return axios.post(`${URL}/login`, data);
};

export const sendEmailOtp = (data) => {
    return axios.post(`${URL}/send-email-otp`, data);
};

export const verifyEmailOtp = (data) => {
    return axios.post(`${URL}/login-email`, data);
};

export const getUserByIdApi = (id) => {
    return axios.get(`${URL}/user/${id}`);
};

export const createPackageApi = async (data) => {
    try {
        return await axios.post(`${URL}/package/create`, data);
    } catch (error) {
        console.log("Error while adding packages", error);
        throw error;
    }
};

export const getAllPackagesApi = async () => {
    try {
        const response = await axios.get(`${URL}/package/all`);
        return response.data;
    } catch (error) {
        console.log("Error while fetching getAllPackagesApi", error);
        return { success: false, message: "Failed to fetch getAllPackagesApi" };
    }
};
export const getBuilderDropdownApi = async () => {
    try {
        const response = await axios.get(`${URL}/developer/get`);
        return response.data;
    } catch (error) {
        console.log("Error while fetching getBuilderDropdownApi", error);
        return { success: false, message: "Failed to fetch getBuilderDropdownApi" };
    }
};

